import React from "react";
import WhiteErrorTriangleIcon from "./icons/WhiteErrorTriangleIcon";

const ErrorMessageBlock = ({
  errorTitle = "Error.",
  errorSubtitle = "Please try again later.",
}) => {
  return (
    <div className="mb-6 p-4 rounded-md text-center bg-error-gradient">
      <div className="flex justify-center items-center">
        <WhiteErrorTriangleIcon />
      </div>
      <div className="text-white font-semibold mt-3">{errorTitle}</div>
      <div className="text-white font-semibold mt-1">{errorSubtitle}</div>
    </div>
  );
};

export default ErrorMessageBlock;
